<div class="row">
    <!-- Stern/starred -->
    <div class="col-xs-4 col-sm-3 col-md-2 col-lg-1">
        <div style="text-align: center;">
            <i ng-show="vm.consult.stared" class="fa fa-star fa-3x" style="color: #eedd33"></i>
            <i ng-hide="vm.consult.stared" class="fa fa-star-o fa-3x"></i>
        </div>
    </div>
    <!-- tags -->
    <div class="col-xs-8 col-sm-9 col-md-10 col-lg-11">
        <!-- Consult Keywords -->
        <div class="spacer-bottom">
            {{vm.consult.created | date}} &ensp; <span ng-repeat="kw in vm.consult.keywords track by $index"><span class="label label-{{kw.col || primary}}">{{kw.key}}</span>&ensp; </span>
        </div>
        <!-- Exam Labels -->
        <div>
            <!-- old labels -->
            <span ng-repeat="label in vm.consult.examlabels track by $index"
                  ng-hide="vm.consult.examlabelsPrimary || vm.consult.examlabelsSecondary">
              <span class="label label-success">{{label}}</span>&ensp; </span>
            <!-- new primary examlabels labels -->
            <span ng-repeat="plabel in vm.consult.examlabelsPrimary track by $index">
              <!-- PDF vorhanden -->
              <a href="/routes/pdfreader/{{plabel.docid}}" uib-tooltip="Befund PDF Ansicht" ng-show="plabel.docid"
                 target="_blank" style="text-decoration: none">
                <span class="label label-primary">
                  {{plabel.type}}
                </span>&ensp;
              </a>
                <!-- PDF nicht vorhanden -->
              <span class="label label-primary" ng-hide="plabel.docid">
                  {{plabel.type}}
              </span>&ensp;
            </span>
            <!-- new secondary labels -> Gesamtbefund -->
            <span ng-repeat="slabel in vm.consult.examlabelsSecondary track by $index">
              <span class="label label-info">{{slabel.type}}</span>&ensp;
            </span>

        </div>
    </div>
</div>